import React, { useContext, useEffect, useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";

import TicketSkeleton from "@common/components/ticketSkeleton";
import { useTranslation } from "@common/hooks/translation";
import BetType from "@tickets/modules/ticketDetails/components/betType";
import { BetStatus } from "@tickets/modules/ticketDetails/components/betStatus";
import { ProviderTypes } from "@app/dev/constants/providerTypes";
import Checkbox from "@common/components/checkbox";
import { getTicketStateName } from "@tickets/helpers/ticketState";
import { isPay } from "@tickets/helpers/actions/isActionAvailable";
import { getTicketIndex } from "@tickets/helpers/actions/pay";
import { getTicketWinAmount } from "@tickets/helpers/getTicketWinAmount";
import { getTicketId } from "@tickets/helpers/getTicketId";
import Money from "@app/dev/terminal/components/money";
import Config from "@skin_config";
import CardActions from "./actions";
import OddConverter from '@common/helpers/oddConverter';
import { PreferencesContext } from "@common/contexts/preferences";

const CardItem = ({ ticket, tickets, onCashout, defaultCashoutAmount, setTickets }) => {
  const t = useTranslation();
  const [cashoutAmount, setCashoutAmount] = useState(0);
  const [preferences] = useContext(PreferencesContext);

  useEffect(() => {
    if (defaultCashoutAmount) setCashoutAmount(defaultCashoutAmount);
  }, [defaultCashoutAmount]);

  const swarmPrice = ticket.dataFromSwarm?.price;
  const ticketPrice = swarmPrice === -1 ? t("SP") : swarmPrice ?? "-";
  const casinoProviderId = ticket.dataFromCasino?.ProviderId;
  const { isPayable } = getTicketStateName(ticket);

  const checkTicket = () => {
    const updatedStatus = !ticket.isChecked;
    const ticketIndex = getTicketIndex(ticket, tickets);
    const updatedTickets = [...tickets[ticket.ticketType]];

    updatedTickets[ticketIndex] = { ...ticket, isChecked: updatedStatus };
    setTickets({
      ...tickets,
      [ticket.ticketType]: updatedTickets,
    });
  };

  const winAmount = getTicketWinAmount(ticket) ?? ticket.dataFromCasino?.TotalWinAmount;
  const totalJackpotAmount = ticket.dataFromCasino?.TotalJackpotWinAmount;
  const isPayTicket = isPay(ticket, isPayable, winAmount);
  const possibleWin = ticket.dataFromSwarm?.possible_win ?? ticket.possible_win ?? ticket.dataFromCasino?.possible_win;
  const betAmount = ticket.dataFromSwarm?.amount ?? ticket.amount ?? ticket.dataFromCasino?.Amount;

  useEffect(() => {
    if (!isPayTicket && ticket.isChecked) {
      checkTicket();
    }
  }, [isPayTicket]);

  return (
    <TicketSkeleton>
      <div className="ticket-section">
        <div className="ticket-info-row">
          <div className="ticket-id-wrapper">
            {isPayTicket && Config.main.isTicketsCheckable && (
              <Checkbox onChange={checkTicket} checked={ticket.isChecked} />
            )}
           {!isPayTicket && <p>{t("Id")}</p>}
          </div>
          <span>{getTicketId(ticket)}</span>
        </div>
        <div className="ticket-info-row">
          <p>{t("Status")}</p>
          <BetStatus data={ticket} />
        </div>
        <div className="ticket-info-row">
          <p>{t("DATE")}</p>
          <span>
            {moment(ticket.dataFromSwarm?.created || ticket.dataFromCasino?.BetMultiplyInfo[0]?.CreateDate).format(
              "DD/MM/YYYY HH:mm:ss"
            )}
          </span>
        </div>
        <div className="ticket-info-row">
          {casinoProviderId ? (
            <>
              <p>{t("Provider")}</p>
              <p>{ProviderTypes[casinoProviderId]}</p>
            </>
          ) : (
            <>
              <p>{t("Bet Type")}</p>
              <BetType data={ticket} />
            </>
          )}
        </div>
        <div className="ticket-info-row">
          <p>{t("Total odd")}</p>
          <p>{OddConverter(Config, ticketPrice, preferences.oddsFormat)}</p>
        </div>
        <div className="ticket-info-row">
          <p>{t("Bet Amount")}</p>
          <p>{betAmount}</p>
        </div>
        <div className="ticket-info-row">
          <p>{t("Possible win amount")}</p>
          <p>{possibleWin === -1 ? 'SP' : possibleWin}</p>
        </div>
        <div className="ticket-info-row">
          <p>{t("Win amount")}</p>
          <p className="win-amount">
            <Money amount={winAmount} />
          </p>
        </div>
        {!!totalJackpotAmount && (
          <div className="ticket-info-row">
            <div className="ticket-info-row-left-info">
              <i className="global-icon icon-jackpot" />
              <p className="ticket-info-row-label">{t("Jackpot")}</p>
            </div>
            <p className="win-amount">{totalJackpotAmount}</p>
          </div>
        )}
      </div>
      <CardActions
        ticket={ticket}
        setTickets={setTickets}
        // onSuccessAction={onSuccessAction}
        tickets={tickets}
        cashoutAmount={cashoutAmount}
        onCashout={onCashout}
        winAmount={winAmount}
        onCashoutAmountChange={setCashoutAmount}
      />
    </TicketSkeleton>
  );
};

export default CardItem;

CardItem.propTypes = {
  ticket: PropTypes.object,
  tickets: PropTypes.object,
  setTickets: PropTypes.func,
};
